import { DatePicker, Input, Select, Button } from 'antd'
import React from 'react'
import { css } from '../style/styles'
import { InputSearchStyle } from '../../customer/common/styled'
import SvgIcon from 'src/components/SvgIcon'
import dayjs from 'dayjs'
import { ReloadOutlined } from '@ant-design/icons'
import "../style/selectStyle.css"

const Filter = ({ onSearch, inputSearchRef, setIsModalImport, params, setParams, listPersponel = [], isAdmin = true }) => {
    const handleResetFilter = () => {
        if (inputSearchRef) inputSearchRef.current = "";
        setParams({
            page: 1,
            per_page: params.per_page || 10,
            keyword: "",
            type: undefined,
            status: undefined,
            sign_status: undefined,
            startDateFrom: undefined,
            startDateTo: undefined,
            endDateFrom: undefined,
            endDateTo: undefined,
            personnel_id: undefined,
        });
    };

    const hasActiveFilters = Boolean(
        params.type ||
        params.status ||
        params.sign_status ||
        params.startDateFrom ||
        params.startDateTo ||
        params.endDateFrom ||
        params.endDateTo ||
        params.personnel_id ||
        params.keyword
    );

    return (
        <div style={{ ...css.card, padding: "12px 16px", display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
            {/* LEFT FILTERS */}
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "10px" }}>
                {/* 1. Loại hợp đồng */}
                <Select
                    allowClear
                    value={params.type}
                    placeholder="Loại hợp đồng"
                    onChange={(value) => setParams({ ...params, page: 1, type: value })}
                    style={{ width: 165, height: "37px" }}
                    options={[
                        { value: "labor", label: "👔 HĐ Lao động" },
                        { value: "collaborator", label: "🤝 Cộng tác viên" },
                    ]}
                />

                {/* 2. Trạng thái */}
                <Select
                    allowClear
                    placeholder="Trạng thái"
                    value={params.status}
                    onChange={(value) => setParams({ ...params, page: 1, status: value })}
                    style={{ width: 185, height: "37px" }}
                    options={[
                        { value: "active", label: "🟢 Đang hiệu lực" },
                        { value: "pending", label: "🟠 Đang chờ 2 bên ký" },
                        { value: "terminated", label: "🔴 Đã kết thúc" },
                    ]}
                />

                {/* 3. Tiến trình ký điện tử */}
                <Select
                    allowClear
                    placeholder="Tiến trình ký điện tử"
                    value={params.sign_status}
                    onChange={(value) => setParams({ ...params, page: 1, sign_status: value })}
                    style={{ width: 220, height: "37px" }}
                    options={[
                        { value: "completed", label: "🟢 Hoàn tất (Đã ký 2 bên)" },
                        { value: "waiting_manager", label: "🟣 Chờ Sếp duyệt & Đóng dấu" },
                        { value: "pending", label: "🟠 Chờ NV ký (Bên B)" },
                    ]}
                />

                {/* 4. Ngày bắt đầu */}
                <DatePicker.RangePicker
                    format="DD/MM/YYYY"
                    style={{ width: "230px", height: "37px" }}
                    value={
                        params.startDateFrom && params.startDateTo
                            ? [dayjs(params.startDateFrom), dayjs(params.startDateTo)]
                            : null
                    }
                    placeholder={["Bắt đầu từ", "đến ngày"]}
                    onChange={(dates) => {
                        if (!dates) {
                            setParams({ ...params, page: 1, startDateFrom: undefined, startDateTo: undefined });
                            return;
                        }
                        setParams({
                            ...params,
                            page: 1,
                            startDateFrom: dayjs(dates[0]).format("YYYY-MM-DD"),
                            startDateTo: dayjs(dates[1]).format("YYYY-MM-DD")
                        });
                    }}
                />

                {/* 5. Lọc Họ tên nhân sự (Chỉ Admin / Quản lý) */}
                {isAdmin && (
                    <Select
                        allowClear
                        showSearch
                        placeholder="Lọc Họ tên nhân sự"
                        value={params.personnel_id}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                        onChange={(value) => setParams({ ...params, page: 1, personnel_id: value })}
                        style={{ width: 195, height: "37px" }}
                        options={(listPersponel || []).map((p) => ({
                            value: p.ID || p.id,
                            label: p.name ? `${p.name}${p.code ? ` (${p.code})` : ''}` : `Nhân sự #${p.ID || p.id}`,
                        }))}
                    />
                )}

                {/* 6. Reset filter button */}
                {hasActiveFilters && (
                    <Button
                        icon={<ReloadOutlined />}
                        onClick={handleResetFilter}
                        style={{ height: "37px", borderRadius: 6, fontWeight: 500 }}
                    >
                        Xóa bộ lọc
                    </Button>
                )}
            </div>

            {/* RIGHT SEARCH */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <InputSearchStyle>
                    <Input
                        className="custom-input"
                        maxLength={50}
                        placeholder="Tìm kiếm theo họ tên nhân sự, mã HĐ..."
                        defaultValue={params.keyword}
                        onChange={e => (inputSearchRef.current = e.currentTarget.value)}
                        onPressEnter={onSearch}
                    />
                    <div className="custom-icon-search">
                        <SvgIcon name="searchStatistic" onClick={onSearch} />
                    </div>
                </InputSearchStyle>
            </div>
        </div>
    )
}

export default React.memo(Filter)
